/* Restaurant Halong 2026-10-08 (Nachbesserung UI-Prüfung, Befund H2): nach dem Hinzufügen den Warenkorb so
   aktualisieren, wie das Theme es erwartet (mit Sektions-HTML), das Gericht-Fenster sauber schließen und das
   Warenkorb-Fenster öffnen. Vorher fehlte "sections", CartDrawer._onCartChanged warf einen TypeError und der Gast
   sah nur den Zähler. */
/* Restaurant Halong 2026-10-09 (UI-Prüfung, KRITISCH "Drawer ohne Fuß"): Laden, Prüfen und Melden des Warenkorbs
   übernimmt assets/halong-warenkorb.js (eine Quelle der Wahrheit, nur die letzte Antwort zählt, Fuß-Invariante).
   Hier bleibt nur das Schließen des Gericht-Fensters. Fehlt das Modul (Rückweg), lädt das Theme den Drawer neu. */
window.halongNachHinzufuegen = function (popupClass) {
  if (popupClass) {
    var $close = $('[data-popup-close="' + popupClass + '"]').first();
    if ($('[data-popup="' + popupClass + '"]').hasClass('activePopup') && $close.length) { $close.trigger('click'); }
  }
  if (window.__halongWarenkorb) return window.__halongWarenkorb.nachHinzufuegen();
  document.dispatchEvent(new CustomEvent('cart:refresh'));
  return Promise.resolve();
};

/* Restaurant Halong 2026-10-09: Hinzufügen abgelehnt (z. B. 422 ausverkauft) oder Netzfehler. Erwartbarer Fall,
   daher Warnung statt Konsolenfehler, Hinweis an den Gast und Abgleich, damit der Drawer den echten Stand zeigt. */
window.halongHinzufuegenFehlgeschlagen = function (fehler) {
  console.warn('[halong] Gericht konnte nicht hinzugefügt werden:', fehler);
  // 2026-10-09 (H-D): Hinweisleiste statt Browser-Dialog, Wortlaut unverändert.
  window.halongHinweis('Das Gericht konnte nicht in den Warenkorb gelegt werden. Bitte erneut versuchen oder anrufen.');
  if (window.__halongWarenkorb) window.__halongWarenkorb.planeAbgleich('hinzufuegen-fehler');
};

/* Restaurant Halong 2026-10-09 (H-B, H-D): Pflichtwahl in den Gericht-Fenstern. Vorher ließ sich „Reis oder Nudeln“
   per Enter ohne Wahl bestellen (.disabled sperrt nur die Maus), und fehlende Wahl meldete ein alert(). Jetzt prüft
   ein Listener in der Capture-Phase vor allen Theme-Handlern und zeigt einen Hinweis direkt über dem Knopf.
   Keine Vorwahl bei zwei Gratis-Optionen (Invariante Arbeitsplan: Mittagsmenü-Fenster nicht vorwählen). */
window.halongHinweis = function (text) {
  var el = document.querySelector('.halong-toast');
  if (!el) {
    el = document.createElement('div');
    el.className = 'halong-toast';
    el.setAttribute('role', 'status');
    document.body.appendChild(el);
  }
  el.textContent = text;
  el.classList.add('is-visible');
  clearTimeout(el._halongTimer);
  el._halongTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 6000);
};

window.halongPflichtHinweis = function (btn, text) {
  // Als eigene erste Zeile in die Knopfleiste: im Wok-Fenster ist sie unten fixiert,
  // ein Hinweis davor läge dahinter.
  var $zeile = $(btn).parent();
  var $alt = $zeile.children('.halong-pflicht-hinweis');
  if ($alt.length) { $alt.text(text); return; }
  $zeile.addClass('halong-hat-hinweis');
  $('<p class="halong-pflicht-hinweis" role="alert"></p>').text(text).prependTo($zeile);
};

function halongSchrittText($step) {
  var titel = $.trim($step.find('.stepTitles').first().text());
  if (/^Wähle /.test(titel)) return 'Bitte w' + titel.slice(1) + '.';
  if (/^Beilage/.test(titel)) return 'Bitte wähle eine Beilage.';
  return 'Bitte triff eine Auswahl.';
}

// Liefert den Hinweistext, wenn vor diesem Knopf noch eine Wahl fehlt, sonst ''.
window.halongFehlendeWahl = function (btn) {
  var $btn = $(btn);
  if ($btn.hasClass('confirmAddon')) {
    if (!$btn.is('[data-halong-pflicht]')) return '';
    var $radios = $btn.closest('.popup').find('input[name="addon"]');
    if (!$radios.length || $radios.filter(':checked').length) return '';
    var namen = $radios.map(function () { return $(this).data('title'); }).get().filter(Boolean);
    if (!namen.length) return 'Bitte triff eine Auswahl.';
    var liste = namen.length > 1 ? namen.slice(0, -1).join(', ') + ' oder ' + namen[namen.length - 1] : namen[0];
    return 'Bitte wähle: ' + liste + '.';
  }
  var $step = $btn.closest('.step');
  if (!$step.length) return '';
  var $wahl = $step.find('input[type="radio"]');
  if (!$wahl.length || $wahl.filter(':checked').length) return '';
  return halongSchrittText($step);
};

// Knöpfe eines Fensters nach der aktuellen Wahl sperren oder freigeben (Optik und aria-disabled).
window.halongKnopfStatus = function ($popup) {
  $popup.find('.step .next, .step .confirmWok, .confirmAddon[data-halong-pflicht]').each(function () {
    var offen = window.halongFehlendeWahl(this) !== '';
    $(this).toggleClass('disabled', offen).attr('aria-disabled', offen ? 'true' : 'false');
  });
};

window.halongFensterStart = function ($popup) {
  $popup.find('.halong-pflicht-hinweis').remove();
  var $steps = $popup.find('.step');
  if ($steps.length) {
    $steps.removeClass('active');
    $steps.first().addClass('active');
  }
  window.halongKnopfStatus($popup);
};

document.addEventListener('click', function (e) {
  var btn = e.target && e.target.closest ? e.target.closest('.confirmAddon, .confirmWok, .stepsForm .next') : null;
  if (!btn) return;
  var text = window.halongFehlendeWahl(btn);
  if (!text) return;
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();
  window.halongPflichtHinweis(btn, text);
}, true);

jQuery(function ($) {
  $('.confirmAddon.disabled').attr('data-halong-pflicht', '');
  $('.popup').each(function () { window.halongKnopfStatus($(this)); });
  $(document).on('change', '.popup input[type="radio"]', function () {
    var $popup = $(this).closest('.popup');
    $popup.find('.halong-pflicht-hinweis').remove();
    window.halongKnopfStatus($popup);
  });
});

$(document).ready(function(){

$('[data-popup-open]').on('click', function (e) {
  var targeted_popup_class = $(this).attr('data-popup-open');
  // Restaurant Halong 2026-10-09 (H-C): Gericht im ausgeblendeten Mittagsmenü nicht öffnen. Vorher blieb die
  // Seite gesperrt (body.lock), während das Fenster unsichtbar war.
  if ($(this).closest('[data-lunch-menu="false"]').length) {
    e.preventDefault();
    window.halongHinweis('Dieses Gericht gibt es nur im Mittagsmenü (Dienstag bis Samstag, 11 bis 15 Uhr).');
    return;
  }
  var scrollPosition = $(window).scrollTop(); // Get the current scroll position

  // Restaurant Halong 2026-10-09 (H-D): jedes Fenster beginnt beim ersten Schritt. Vorher merkte sich ein globaler
  // Zähler den Schritt des zuletzt geschlossenen Fensters, das nächste Wok-Fenster startete bei Schritt 2.
  $('[data-popup="' + targeted_popup_class + '"]').each(function () { window.halongFensterStart($(this)); });
  $('[data-popup="' + targeted_popup_class + '"]').fadeIn(350);
  $('[data-popup="' + targeted_popup_class + '"]').addClass('activePopup');
  e.preventDefault();

  // Add lock class and fix position
  $('body').addClass('lock').css({
    position: 'fixed',
    top: -scrollPosition + 'px', // Prevent scroll jump
    width: '100%',
  });

  $('.popupOverlay').fadeIn(350);
  // Store the scroll position for unlocking later
  $('body').data('scroll-position', scrollPosition);
});   
  
$('[data-popup-close]').on('click', function (e) {
  var targeted_popup_class = $(this).attr('data-popup-close');
  var scrollPosition = $('body').data('scroll-position'); // Get stored scroll position

  $('[data-popup="' + targeted_popup_class + '"]').fadeOut(350);
  $('[data-popup="' + targeted_popup_class + '"]').removeClass('activePopup');
  e.preventDefault();

  // Remove lock class and restore position
  $('body').removeClass('lock').css({
    position: '',
    top: '',
    width: '',
  });
  // $('html').removeClass('lock');
  $(window).scrollTop(scrollPosition); // Restore scroll position
  $('.popupOverlay').fadeOut(350);
});
  
$('input[name="addon"]').on('change', function () {       
    var basePriceStr = $(this).attr('data-price'); // Addon price
    var addonPriceStr = $(this).attr('data-price-base'); // Base product price (seems you mixed comments, corrected)
    var dataProductId = $(this).attr('data-product-id');    
    
    // Remove currency symbol (€) and parse properly (comma to dot too!)
    var basePrice = parseFloat(basePriceStr.replace('€', '').replace(',', '.'));
    var addonPrice = parseFloat(addonPriceStr.replace('€', '').replace(',', '.'));    
    
    var selectedQty = $('.activePopup .addOnQty').val() || 1; // Always fallback to 1 if empty (smart fallback)
    var totalPrice = (addonPrice + basePrice) * selectedQty;    

    $('#quantity-' + dataProductId).val(selectedQty);

    var formattedPrice = totalPrice.toFixed(2).replace('.', ',');

    $('[data-product-id="' + dataProductId + '"] .confirmPrice').text(formattedPrice + ' €');
});

$('.confirmAddon').on('click', function (e) {
  e.preventDefault();    

  var productId = $(this).data('product-id');
  var variantId = $(this).data('variant-id');
  var productTag = $(this).data('tag');
  var prodQty =  $('#quantity-'+productId).val();
  var targetedPopupClass = `popup-${productId}`;    
  var selectedAddon = $(`#addonForm-${productId} input[name="addon"]:checked`);  
  var addonId = selectedAddon.val();
  if(selectedAddon.length !== 0 && selectedAddon.data('price') !== '0,00 €' ){        
    var addonTitle = selectedAddon.data('title'); // Get the add-on title
    var addonQty = $(`#addOnQty${productId}`).val(); // Get the add-on quantity        
    var addonbasePrice  = parseFloat(selectedAddon.data('price').replace('€', ''));
    var addonprice  = addonbasePrice * addonQty;
    // Combine title and quantity into a single string
    var addonDetails = `${addonTitle}`;       
    $(`#addOnProduct-${productId}`).val(addonDetails);    
    var addonId = selectedAddon.val();
    var productTitle = $(this).data('product-title');

    // Restaurant Halong 2026-10-08: Gericht und Beilage in EINEM Aufruf (ganz oder gar nicht),
    // verknüpft über die versteckte Kennung _Gruppe. Abgleich im Warenkorb: halong-beilage.js.
    // Kennung aus Gericht und Beilage berechnet (nicht zufällig), damit gleiche Auswahl zu einer Zeile mit Menge zusammenläuft. Karim 08.10.
    var halongKennung = function (s) { var h = 2166136261; for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return (h >>> 0).toString(36); };
    var gruppe = 'b' + halongKennung(JSON.stringify([variantId, addonId, productTitle, selectedAddon.data('title')]));
    var menge = Number(prodQty) || Number(addonQty) || 1;
    fetch(`${Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [
        { id: addonId, quantity: menge, properties: { 'Beilage für': productTitle, _Gruppe: gruppe } },
        { id: variantId, quantity: menge, properties: { 'Beilage': selectedAddon.data('title'), _Gruppe: gruppe } }
      ] })
    })
      .then(function (res) {
        if (!res.ok) return res.json().catch(function () { return {}; }).then(function (err) { throw new Error(err.description || ('HTTP ' + res.status)); });
        return res.json();
      })
      .then(function () { return window.halongNachHinzufuegen(targetedPopupClass); })
      .catch(function (error) { window.halongHinzufuegenFehlgeschlagen(error); })
      .finally(function () {
        $('body').removeClass('lock');
        $('html').removeClass('lock');
      });
  }
  else{

    if(productTag && productTag == "Mittagsmenue-Angebot"){

       $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: variantId,
        quantity: prodQty,
        properties: {
          'Gratis Vorspeise': selectedAddon.data('title')
        }
      },
      dataType: 'json',
      success: function () {
        window.halongNachHinzufuegen(targetedPopupClass);
      },
      error: function (xhr, status, error) {
        window.halongHinzufuegenFehlgeschlagen((xhr && xhr.responseJSON && xhr.responseJSON.description) || error || status);
      },
    });

    }else{
   $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: variantId,
        quantity: prodQty,
        properties: {
          'Beilage': selectedAddon.data('title')
        }
      },
      dataType: 'json',
      success: function () {
        window.halongNachHinzufuegen(targetedPopupClass);
      },
      error: function (xhr, status, error) {
        window.halongHinzufuegenFehlgeschlagen((xhr && xhr.responseJSON && xhr.responseJSON.description) || error || status);
      },
    });
    }

   
    

        // $(`#addOnProduct-${productId}`).val(selectedAddon.data('title'));
        // $(`.${targetedPopupClass} button`).click(); // Trigger popup close button click          
        // $(`[data-popup="${targetedPopupClass}"]`).fadeOut(350); // Close popup
        // $('body').removeClass('lock');
        // $('.popupOverlay').fadeOut(350);
  }
});

  var prevValSingle = '';
$(document).on('click', '.activePopup .plusButtonSingle', function (e) {
    prevValSingle = $(this).siblings('.addOnQty').val();
    var selectedAddon = $(this);
    var dataProductId = selectedAddon.attr('data-product-id');
    var basePriceStr = selectedAddon.attr('data-price-base');

    // Remove € symbol and fix comma to dot for float parsing
    var basePrice = parseFloat(basePriceStr.replace('€', '').replace(',', '.'));

    var selectedQty = $('.activePopup .addOnQty').val();
    $('#quantity-' + dataProductId).val(selectedQty);

    var totalPrice = basePrice * selectedQty;

    // Force always two decimals and replace dot with comma
    var formattedPrice = totalPrice.toFixed(2).replace('.', ',');

    $('[data-product-id="' + dataProductId + '"] .confirmPrice').text(formattedPrice + ' €');
});

$(document).on('click', '.activePopup .MinusButtonSingle', function (e) {
    if ($(this).siblings('.addOnQty').val() > 1 || prevValSingle == 2) {
        var selectedAddon = $(this);
        var dataProductId = selectedAddon.attr('data-product-id');
        
        var basePriceStrProduct = selectedAddon.attr('data-price-base'); 
        var basePriceProduct = parseFloat(basePriceStrProduct.replace('€', '').replace(',', '.'));

        var selectedQty = $('.activePopup .addOnQty').val();
        $('#quantity-' + dataProductId).val(selectedQty);

        var totalPrice = basePriceProduct * selectedQty;
        var formattedPrice = totalPrice.toFixed(2).replace('.', ',');

        $('[data-product-id="' + dataProductId + '"] .confirmPrice').text(formattedPrice + ' €');
    }
    prevValSingle = $(this).siblings('.addOnQty').val();
});

var prevVal = '';

$(document).on('click', '.activePopup .plusButton', function (e) {
    prevVal = $(this).siblings('.addOnQty').val();
    
    var selectedAddon = $(this).closest('.productBlockBtn')
                               .parent('.addonProductWrapper')
                               .find('.addonRow form input[name="addon"]:checked');
    
    var dataProductId = selectedAddon.attr('data-product-id');
    var basePriceStr = selectedAddon.attr('data-price-base');
    var addonPriceStr = selectedAddon.attr('data-price');

    var basePrice = parseFloat(basePriceStr.replace('€', '').replace(',', '.'));
    var addonPrice = parseFloat(addonPriceStr.replace('€', '').replace(',', '.'));
    
    var selectedQty = $('.activePopup .addOnQty').val();
    $('#quantity-' + dataProductId).val(selectedQty);

    var totalPrice = (basePrice + addonPrice) * selectedQty;
    var formattedPrice = totalPrice.toFixed(2).replace('.', ',');

    $('[data-product-id="' + dataProductId + '"] .confirmPrice').text(formattedPrice + ' €');
});

$(document).on('click', '.activePopup .MinusButton', function (e) {
    if ($(this).siblings('.addOnQty').val() > 1 || prevVal == 2) {
        var selectedAddon = $(this).closest('.productBlockBtn')
                                   .parent('.addonProductWrapper')
                                   .find('.addonRow form input[name="addon"]:checked');
        
        var dataProductId = selectedAddon.attr('data-product-id');
        var basePriceStrProduct = selectedAddon.attr('data-price-base');
        var addonPriceStr = selectedAddon.attr('data-price');

        var basePriceProduct = parseFloat(basePriceStrProduct.replace('€', '').replace(',', '.'));
        var addonPrice = parseFloat(addonPriceStr.replace('€', '').replace(',', '.'));
        
        var selectedQty = $('.activePopup .addOnQty').val();
        $('#quantity-' + dataProductId).val(selectedQty);

        var subtotalPrice = basePriceProduct + addonPrice;
        var totalPrice = subtotalPrice * selectedQty;
        var formattedPrice = totalPrice.toFixed(2).replace('.', ',');

        $('[data-product-id="' + dataProductId + '"] .confirmPrice').text(formattedPrice + ' €');
    }
    prevVal = $(this).siblings('.addOnQty').val();
});

$(document).on('click','.collection-template .content-over-media', function (e) {
        e.preventDefault(); // Prevent the default anchor behavior
        const target = $($(this).attr('href')); // Get the target element                
        if (target.length) {
            const viewportWidth = $(window).width();            
            // Define different offsets for desktop and mobile
            const offset = viewportWidth > 768 ? 270 : 200; // Adjust values as needed            
            $('html, body').animate({
                scrollTop: target.offset().top - offset
            }, 800); // Adjust duration for smoothness
        }      
      });  
   
});


const now = new Date();
const options = { timeZone: 'Europe/Berlin', hour: '2-digit', minute: '2-digit', weekday: 'long', hour12: false };
const parts = new Intl.DateTimeFormat('en-US', options).formatToParts(now);

let weekday = parts.find(p => p.type === 'weekday').value;
let hour = parseInt(parts.find(p => p.type === 'hour').value);
let minute = parseInt(parts.find(p => p.type === 'minute').value);

const totalMinutes = (hour * 60) + minute;
const allowedDays = ['Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

// Restaurant Halong 2026-10-09 (M-4): an Tagen aus Theme-Einstellungen > Abholzeit > „Geschlossene Tage“ kein Mittagsmenü.
// Gleiches Format wie die Abholzeit (halong-abholzeit.js, parseClosedDates): TT.MM.JJJJ, getrennt durch Zeilen, Komma oder Leerzeichen.
const halongHeute = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit' }).format(now);
const halongHeuteGeschlossen = (function (text) {
  // 24.12.2026, 13.10.26 und Zeiträume "von - bis" / "von bis bis"; Logik wie parseClosedDates in halong-abholzeit.js.
  var re = /(\d{1,2})\.(\d{1,2})\.(\d{4}|\d{2})(?!\d)(?:\s*(?:-|–|—|bis)\s*(\d{1,2})\.(\d{1,2})\.(\d{4}|\d{2})(?!\d))?/gi;
  var iso = function (d, m, y) { return (y.length === 2 ? '20' + y : y) + '-' + ('0' + m).slice(-2) + '-' + ('0' + d).slice(-2); };
  var m;
  while ((m = re.exec(String(text || ''))) !== null) {
    var von = iso(m[1], m[2], m[3]);
    var bis = m[4] ? iso(m[4], m[5], m[6]) : von;
    if (von <= halongHeute && halongHeute <= bis) return true;
  }
  return false;
})(window.halongGeschlosseneTage);

const isLunchTime = !halongHeuteGeschlossen && allowedDays.includes(weekday) && totalMinutes >= 660 && totalMinutes <= 900;

// Restaurant Halong 2026-10-09 (R-009): erst nach dem Laden der Seite setzen. Das Skript steht im HTML vor
// #mittagsmenu; beim direkten Aufruf gab es die Elemente noch nicht, das Mittagsmenü blieb auch mittags verborgen.
jQuery(function ($) {
  $('[data-lunch-menu]').each(function() {
    $(this).attr('data-lunch-menu', isLunchTime ? 'true' : 'false');
  });
});

// Restaurant Halong 2026-10-08 (UI-Prüfung H3): Suchtreffer führen auf /collections/speisekarte#gericht-<id>;
// hier wird das Gericht in die Mitte gescrollt und sein Fenster geöffnet. Ohne passendes Fenster bleibt die Speisekarte offen.
jQuery(function ($) {
  var treffer = /^#gericht-(\d+)$/.exec(window.location.hash || '');
  if (!treffer) return;
  setTimeout(function () {
    var id = 'popup-' + treffer[1];
    var $alle = $('.popupOpener[data-popup-open="' + id + '"]');
    // H-C (2026-10-09): nur Öffner außerhalb des ausgeblendeten Mittagsmenüs; sonst Hinweis statt gesperrter Seite.
    var $opener = $alle.filter(function () { return !$(this).closest('[data-lunch-menu="false"]').length; }).first();
    if (!$opener.length && $alle.length) {
      window.halongHinweis('Dieses Gericht gibt es nur im Mittagsmenü (Dienstag bis Samstag, 11 bis 15 Uhr).');
      return;
    }
    var popup = document.querySelector('[data-popup="' + id + '"]');
    if (!$opener.length || !popup) return;
    var reveal = $opener[0].closest('reveal-items') || popup.closest('reveal-items');
    if (reveal) reveal.style.opacity = '1';
    ($opener.closest('product-card')[0] || $opener[0]).scrollIntoView({ block: 'center' });
    $opener.trigger('click');
  }, 300);
});
